/** Hermes 品牌站创作会话：context / 复用键（见 Plan 3）。 */

export type BrandSiteAuthoringContext = {
  mode: "brand_site_authoring";
  accountId: string;
  brandId: number;
  brandSiteId: number;
};

export function brandSiteAuthoringChatContext(ctx: BrandSiteAuthoringContext) {
  return {
    mode: "brand_site_authoring" as const,
    brand_id: ctx.brandId,
    brand_site_id: ctx.brandSiteId,
  };
}

export function clearBrandSiteAuthoringModeContext() {
  return { mode: null as null };
}

/** 切站后须换会话 context，避免 Hermes 仍写上一座站 */
export function shouldReplaceBrandSiteAuthoring(
  current: Pick<BrandSiteAuthoringContext, "brandSiteId"> | null | undefined,
  nextSiteId: number,
): boolean {
  if (!current) return false;
  return Number(current.brandSiteId) !== Number(nextSiteId);
}

export function matchesBrandSiteAuthoringChat(
  chat: { context?: Record<string, unknown> | null },
  ctx: Pick<BrandSiteAuthoringContext, "brandId" | "brandSiteId">,
): boolean {
  const context = chat.context;
  if (!context || typeof context !== "object") return false;
  if (context.mode !== "brand_site_authoring") return false;
  if (Number(context.brand_id) !== ctx.brandId) return false;
  return Number(context.brand_site_id) === ctx.brandSiteId;
}

export function isBrandSiteAuthoringChat(chat: {
  context?: Record<string, unknown> | null;
}): boolean {
  return chat.context?.mode === "brand_site_authoring";
}

export function brandSiteAuthoringFromChat(
  chat: { context?: Record<string, unknown> | null },
  accountId: string,
): BrandSiteAuthoringContext | null {
  const context = chat.context;
  if (!context || typeof context !== "object") return null;
  if (context.mode !== "brand_site_authoring") return null;
  const brandId = Number(context.brand_id);
  const brandSiteId = Number(context.brand_site_id);
  if (!Number.isFinite(brandId) || brandId <= 0) return null;
  if (!Number.isFinite(brandSiteId) || brandSiteId <= 0) return null;
  return { mode: "brand_site_authoring", accountId, brandId, brandSiteId };
}

/** 当前是否在该账户的 AI 官网工具内（编辑页用于准备「本轮能力」）。 */
export function isBrandSiteAppRoute(pathname: string, accountId: string): boolean {
  if (!accountId || !pathname) return false;
  const match = pathname.match(/\/accounts\/([^/]+)\/brands\/\d+\/apps\/brand_site\/sites\//);
  return Boolean(match && match[1] === accountId);
}

export function brandSiteCapabilityChipLabel(): string {
  return "AI 官网";
}

/** 聊天里折叠整页源码，避免刷屏；不代表已写入官网。 */
export function collapseHtmlFencesForChat(markdown: string): string {
  const text = markdown ?? "";
  if (!text.trim()) return text;
  let next = text.replace(/```html\s*\n[\s\S]*?```/gi, "（一份 HTML 已折叠，未写入官网）");
  next = next.replace(/```html\s*\n[\s\S]*$/i, "（正在折叠 HTML…）");
  return next.replace(/\n{3,}/g, "\n\n").trim();
}
